// App: composition root. Reads from @content/ and passes content down to UI as props.
// This is the only place UI meets content; sections themselves take props only.

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Layout } from '@ui/chrome';
import {
  HomeRoute,
  ProjectsRoute,
  WritingRoute,
  ExperienceRoute,
  ContactRoute,
  VideosRoute,
  NotFoundRoute,
} from '@routes/index';
import { site } from '@content/site';
import {
  allyContext,
  allyGreeting,
  allySuggestions,
  allyTriggerLabel,
  allyPanelLabel,
  allyPanelSubtitle,
  allyCloseLabel,
  allyInputPlaceholder,
  allyMessageLabel,
  allySendLabel,
} from '@content/ally-context';

const layoutProps = {
  documentTitle: site.seo.title,
  pages: site.pages,
  showAlly: true,
  links: {
    calendly:  site.links['calendly'] ?? '#',
    x:         site.links['x'] ?? '#',
    xhandle:   site.links['xhandle'] ?? '',
    linkedin:  site.links['linkedin'] ?? '#',
    github:    site.links['github'] ?? '#',
    blog:      site.links['blog'] ?? '#',
    resume:    site.links['resume'] ?? '/resume.pdf',
  },
  ally: {
    context: allyContext,
    greeting: allyGreeting,
    suggestions: allySuggestions,
    copy: {
      triggerLabel: allyTriggerLabel,
      panelLabel: allyPanelLabel,
      panelSubtitle: allyPanelSubtitle,
      closeLabel: allyCloseLabel,
      inputPlaceholder: allyInputPlaceholder,
      messageLabel: allyMessageLabel,
      sendLabel: allySendLabel,
    },
  },
};

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout {...layoutProps} />,
    children: [
      { index: true,        element: <HomeRoute /> },
      { path: 'experience', element: <ExperienceRoute /> },
      { path: 'projects',   element: <ProjectsRoute /> },
      { path: 'videos',     element: <VideosRoute /> },
      { path: 'writing',    element: <WritingRoute /> },
      { path: 'contact',    element: <ContactRoute /> },
      { path: '*',          element: <NotFoundRoute /> },
    ],
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}
